import SavedEmailStatusEnum from 'common/constants/SavedEmailStatusEnum';
import { t } from '@lingui/macro';
import { Alert, Sticky } from '@onsolve/onsolve-ui-components';
import React from 'react';
import styles from './RenderBanner.module.scss';
const RenderBanner = ({ messages = [], isEmailSaved = SavedEmailStatusEnum.NONE, isMessageBoxOpen, handleOnClose, }) => {
    return (<ul className={styles.error_wrapper} data-testid="RenderBanner">
            <Sticky placement="top" disabled={false}>
                {isEmailSaved === SavedEmailStatusEnum.SUCCESS && (<Alert color="success" iconClassName={styles.error_hideIcon} className={styles.error_successBox} isOpen={isMessageBoxOpen} onClose={handleOnClose} closeTimeout={10}>
                        {t `Successfully saved changes.`}
                    </Alert>)}
                {isEmailSaved === SavedEmailStatusEnum.ERROR && (<Alert color="danger" iconClassName={styles.error_hideIcon} className={styles.error_errorsBox} isOpen={isMessageBoxOpen} onClose={handleOnClose} closeTimeout={10000 / 1000}>
                        <div className={styles.error_errorColor}>
                            {t `Please correct the following errors:`}
                            {messages.map((message, index) => (<li key={index} className={styles.error_errorText}>
                                    <span>{message}</span>
                                </li>))}
                        </div>
                    </Alert>)}
            </Sticky>
        </ul>);
};
export default RenderBanner;
